/**
 * Arrastar um arquivo do Desk Cloud (o painel Arquivos da mesa) para a cena, o chat ou o player de
 * música (docs/spec/desk-cloud.md): o arraste leva um tipo próprio, com o id, o tipo, o nome e o mime.
 * Durante o arraste o navegador só mostra os tipos; o conteúdo chega ao soltar.
 */
import { FileKindSchema, type FileKind } from '../shared.js';

export const CLOUD_FILE_DRAG = 'application/x-rpgdesk-file';

export type DraggedFile = { id: string; kind: FileKind; name: string; mime: string };

export function setFileDrag(data: DataTransfer, file: DraggedFile): void {
  data.setData(CLOUD_FILE_DRAG, JSON.stringify({ id: file.id, kind: file.kind, name: file.name, mime: file.mime }));
  data.effectAllowed = 'copyLink';
}

/** O arraste traz um arquivo do Desk Cloud (vale também durante o arraste, pelos tipos). */
export const hasFileDrag = (data: Pick<DataTransfer, 'types'>): boolean => [...data.types].includes(CLOUD_FILE_DRAG);

/** O arquivo arrastado, ao soltar; null se não veio um, ou veio torto. */
export function readFileDrag(data: Pick<DataTransfer, 'getData'>): DraggedFile | null {
  try {
    const value = JSON.parse(data.getData(CLOUD_FILE_DRAG)) as Partial<DraggedFile>;
    const kind = FileKindSchema.safeParse(value.kind);
    if (typeof value.id !== 'string' || !value.id || !kind.success || typeof value.name !== 'string' || typeof value.mime !== 'string') return null;
    return { id: value.id, kind: kind.data, name: value.name, mime: value.mime };
  } catch {
    return null;
  }
}
